// extracted by mini-css-extract-plugin
module.exports = {"main__wrapper":"Main_main__wrapper__2ye7K","main__content":"Main_main__content__1zvyc"};